"use client";

import { Input } from "@/components/ui/input";
import { t } from "@/lib/localization";
import { useLocale } from "@/hooks/useLocale";
import type { WizardState } from "./types";

interface Step3Props {
    state: WizardState;
    update: (patch: Partial<WizardState>) => void;
}

export default function Step3Name({ state, update }: Step3Props) {
    const { locale } = useLocale();

    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium">
                    {t("avatars.wizard.step3.name.label", locale)}
                </label>
                <Input
                    value={state.name}
                    onChange={(e) => update({ name: e.target.value })}
                    maxLength={100}
                    autoFocus
                    placeholder={t(
                        "avatars.wizard.step3.name.placeholder",
                        locale
                    )}
                />
                <p className="text-xs text-muted-foreground">
                    {t("avatars.wizard.step3.name.hint", locale)}
                </p>
            </div>
        </div>
    );
}
